import {OWNER_SUCCESS, OWNER_ERROR} from '../actions/owner';

const initialState = {
    data: '',
    error: null
};

export default function reducer(state = initialState, action) {
    if (action.type === OWNER_SUCCESS) {
        return Object.assign({}, state, {
            data: action.data,
            error: null
        });
    } else if (action.type === OWNER_ERROR) {
        return Object.assign({}, state, {
            error: action.error
        });
    }
    return state;
}